import type { MouseEvent } from 'react';
import { LinkProps, useLocation } from 'react-router-dom';

import getEmbeddedLocation from '../utils/get-embedded-location';
import getLocationPathname from '../utils/get-location-pathname';
import { useNavigation } from '../navigation';

import useWizardEmitNavigateEvent from './use-wizard-emit-navigate-event';

const useEmbeddedLinkProps = ({ to, onClick }: Pick<LinkProps, 'to' | 'onClick'>) => {
  const location = useLocation();
  const { restrictedPaths } = useNavigation();
  const emitNavigateEvent = useWizardEmitNavigateEvent();

  const locationDescriptor = typeof to === 'function' ? to(location) : to;
  const embeddedLocation = getEmbeddedLocation(restrictedPaths, locationDescriptor);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const pathname = getLocationPathname(locationDescriptor);
    if (pathname) {
      emitNavigateEvent(pathname);
    }
    onClick?.(event);
  };

  return { onClick: handleClick, to: embeddedLocation ?? '#' };
};

export default useEmbeddedLinkProps;
